import React, { useEffect } from 'react';
import axios from 'axios';

import './HistoryPage.css';

import logoImage from './../../image/logo.svg';
import productPhoto from './../../image/product-photo.png';

const HistoryPage = ({
    setCurrentPage,
    historyList,
    setOrderList,
    setIsShowSuccess,
    setSuccessStatus,
    setIsShowError,
    setErrorStatus,
}) => {
    useEffect(() => {
        console.log('история заказов: ', historyList);
    }, [historyList]);

    // преобразование в локальное время
    const toLocalDate = (dateString) => {
        const date = new Date(dateString);
        const timeZoneOffset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);
        return localDate;
    };

    // группировка заказов по месяцам
    const handleGroupOrders = (historyList) => {
        return historyList.reduce((acc, entry) => {
            const localDate = toLocalDate(entry.date);
            const month = localDate.toLocaleString('ru-RU', { month: 'long' });
            const year = localDate.getFullYear();
            const key = `${
                month.charAt(0).toUpperCase() + month.slice(1)
            } ${year}`;

            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key] = acc[key].concat(entry.orders);
            return acc;
        }, {});
    };

    const groupedOrders = handleGroupOrders(historyList);

    // форматирование даты
    const formatDateOrders = (ordersDate) => {
        const date = new Date(ordersDate);
        const timeZoneOffset = new Date().getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);

        const year = localDate.getFullYear();
        const day = localDate.getDate().toString().padStart(2, '0');
        const month = (localDate.getMonth() + 1).toString().padStart(2, '0');

        return `${day}.${month}.${year}`;
    };

    // форматирование времени
    const formatTimeOrders = (ordersDate) => {
        const date = new Date(ordersDate);
        const timeZoneOffset = new Date().getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);

        const hours = localDate.getHours().toString().padStart(2, '0');
        const minutes = localDate.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    };

    // клик по заказу
    const handleOrderClick = async (order) => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/orders/history/order',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        orderId: order,
                    },
                }
            );
            if (response.data.success) {
                console.log('Данные о заказе: ', response.data.result);
                setOrderList(response.data.result);
                setCurrentPage('OrderPage');
            }
        } catch (error) {
            console.error('Ошибка получения данных о заказе ', error);
        }
    };

    // повторить заказ
    const handleOrderAdd = async (orderId) => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/orders/history/order',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        orderId: orderId,
                    },
                }
            );

            if (response.data.success) {
                const order = response.data.result;
                let newTotalSum = parseInt(
                    localStorage.getItem('totalSum') || 0
                );

                order.orderItems.forEach((item) => {
                    const productInfo = {
                        id: item.productId,
                        name: item.name,
                        price: item.price,
                        quantity: item.amount,
                    };

                    const currentCart = JSON.parse(
                        localStorage.getItem(`product_${item.productId}`)
                    ) || { quantity: 0 };

                    const newQuantity = currentCart.quantity + item.amount;
                    const updatedProductInfo = {
                        ...productInfo,
                        quantity: newQuantity,
                    };

                    localStorage.setItem(
                        `product_${item.productId}`,
                        JSON.stringify(updatedProductInfo)
                    );

                    newTotalSum += item.price * item.amount;
                });

                localStorage.setItem('totalSum', newTotalSum);

                setSuccessStatus(5);
                setIsShowSuccess(true);
            }
        } catch (error) {
            console.error('Ошибка при повторном заказе: ', error);
            setIsShowError(true);
            setErrorStatus(5);
        }
    };

    return (
        <div className='history__wrapper'>
            <div className='history__logo'>
                <img src={logoImage} alt='Logo' />
            </div>
            <h3 className='history__subtitle'>Мои заказы</h3>

            <div className='history__items'>
                {historyList &&
                    Object.entries(groupedOrders).map(([key, orders]) => {
                        const [month, year] = key.split(' ');
                        return (
                            <div className='history__item_block' key={key}>
                                <h3 className='history__items_subtitle'>
                                    {month} <span>{year}</span>
                                </h3>
                                {orders.map((order) => (
                                    <div
                                        className='history__item'
                                        key={order.orderId}
                                        onClick={() =>
                                            handleOrderClick(order.orderId)
                                        }
                                    >
                                        <div className='history__images'>
                                            {order.imagesUrl &&
                                                order.imagesUrl.length > 0 &&
                                                order.imagesUrl
                                                    .slice(0, 4)
                                                    .map((image, index) => (
                                                        <img
                                                            src={
                                                                image
                                                                    ? `https://apihpwild.ru${image}`
                                                                    : productPhoto
                                                            }
                                                            alt={order.orderId}
                                                            key={index}
                                                        />
                                                    ))}
                                        </div>
                                        <div className='history__info'>
                                            <p className='history__info_price'>
                                                {order.price} ₽
                                            </p>
                                            <p className='history__info_date'>
                                                {formatDateOrders(
                                                    order.createdAt
                                                )}
                                            </p>
                                            <p className='history__info_time'>
                                                {formatTimeOrders(
                                                    order.createdAt
                                                )}
                                            </p>
                                        </div>
                                        <div
                                            className='history__btns'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleOrderAdd(order.orderId);
                                            }}
                                        >
                                            Повторить заказ
                                        </div>
                                    </div>
                                ))}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default HistoryPage;
